import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import React from "react";
import styles from "./uni_profile_banner.module.scss";

export const UniProfileBanner = ({ uniProfileData }) => {
  return (
    <section className={styles.section_banner}>
      {uniProfileData?.featureSrc && (
        // <div className={styles.banner_wrapper}>
        <div>
          {/* <img
            src={uniProfileData?.featureSrc}
            alt={uniProfileData?.universityName}
          /> */}
          <Image
            layout="responsive"
            width={1905}
            height={450}
            blurDataURL={getAssets("assets/images/image_placeholder_big.webp")}
            placeholder="blur"
            className={styles.banner_image}
            src={
              uniProfileData?.featureSrc ||
              getAssets("assets/images/image_placeholder_big.webp")
            }
            alt="Video Background"
          />
        </div>
      )}
    </section>
  );
};

export default UniProfileBanner;
